<template>
  <v-card color="#F5F5F5" class="back pa-4 mt-0 report-card">
    <v-card-title>1.10 - {{ $t('Preventiva x Corretiva') }}</v-card-title>
    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="!showChart">
      {{ $t('Nenhum dado encontrado') }}
    </v-alert>
    <v-card-text v-else>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <LineChart
            :chart-data="correntiveXPreventiveChartData"
            :options="options"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-simple-table class="main-table" dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left"></th>
            <th
              class="text-left"
              v-for="month in data.dataByMonth.map((x) => x.month)"
              :key="month"
            >
              {{ month }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="max-width: 60px"></td>
            <td style="max-width: 60px">Corretivas</td>
            <td v-for="item in data.dataByMonth" :key="item.month">
              {{ item.totalCorrective }}
            </td>
          </tr>
          <tr>
            <td style="max-width: 60px"></td>
            <td style="max-width: 60px">Preventivas</td>
            <td v-for="item in data.dataByMonth" :key="item.month">
              {{ item.totalPreventive }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import LineChart from '../../../../Reports/components/charts/lineChart'

export default {
  props: {
    filter: Object,
  },
  components: {
    LineChart,
  },
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      correntiveXPreventive: undefined,
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      correntiveXPreventiveChartData: {},
      corrective: [],
      preventive: [],
      labels: [],
      total: 0,
      data: {
        dataByMonth: [],
      },
    }
  },
  async created() {
    this.listcorrentiveXPreventive()
  },
  methods: {
    async listcorrentiveXPreventive() {
      await this.apiService
        .post('bigData/preventiveCorrective', this.filter)
        .then((response) => {
          this.data = response.content
          this.total = this.data.totalCorrective + this.data.totalPreventive
          this.fillcorrentiveXPreventiveChartData()
        })
        .catch((err) => {})
    },
    fillcorrentiveXPreventiveChartData() {
      this.correntiveXPreventiveChartData = {
        labels: this.data.dataByMonth.map((x) => x.month),
        datasets: [
          {
            label: 'Corretiva',
            data: this.data.dataByMonth.map((x) => x.totalCorrective),
            backgroundColor: 'rgba(26,131,194,0.75)',
            borderColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            tension: 0.2,
          },
          {
            label: 'Preventiva',
            data: this.data.dataByMonth.map((x) => x.totalPreventive),
            backgroundColor: 'rgba(228,150,28,0.69)',
            borderColor: 'white',
            pointRadius: 5,
            pointHoverRadius: 10,
            tension: 0.2,
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.listcorrentiveXPreventive()
    },
  },
}
</script>
